import { render, staticRenderFns } from "./ProgrammaticCampaignEdit.vue?vue&type=template&id=3577cc04"
import script from "./ProgrammaticCampaignEdit.vue?vue&type=script&lang=js"
export * from "./ProgrammaticCampaignEdit.vue?vue&type=script&lang=js"
import style0 from "./ProgrammaticCampaignEdit.vue?vue&type=style&index=0&id=3577cc04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports